// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"575":"3961af91","744":"142c45d4","801":"8b293091","981":"feb658f1"}[chunkId] + ".chunk.js";
};